import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ControlBase } from '../../models/control-base';

@Component({
  selector: 'app-control',
  templateUrl: './form-content.component.html',
  styleUrls: ['./form-content.component.css']
})
export class FormContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @Input() control!: ControlBase<string>;
  @Input() form!: UntypedFormGroup;
  get isValid() { return this.form.controls[this.control.key].valid; }


}
